import "./App.css";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { GlobalTheme } from "./GlobalTheme";
import { StrictMode, Suspense } from "react";
import { PageRoute } from "./components-old/ComponentsIndex";
import { DisplaySpinnerContextProvider } from "./context/ContextIndex";
import { AppToastMsg } from "./components";


function App() {
  return (
    <Suspense fallback="...loading">
      <DisplaySpinnerContextProvider>
        <StrictMode>
          <ThemeProvider theme={GlobalTheme}>
            <CssBaseline />
            <PageRoute />
          </ThemeProvider>
          <AppToastMsg />
        </StrictMode>
      </DisplaySpinnerContextProvider>
    </Suspense>
  );
}

export default App;
